import * as z from 'zod';

import { billingPeriodSchema } from '~/types';

export const signUpFormDataSchema = z.object({
  email: z.string().email(),
  password: z.string().min(6),
  recipientCount: z.number(),
  billingPeriod: billingPeriodSchema,
  paymentMethod: z.string().min(1),
});

export type SignUpFormData = z.infer<typeof signUpFormDataSchema>;
